import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';
import ReactDatePicker from 'react-datepicker';

/* eslint-disable react/prop-types */
function DatePickerInput({ onClick, labelText, value }) {
  const dateRangeParts = value.split('-');
  const dateValue =
    dateRangeParts[0].trim() === dateRangeParts[1].trim() || !dateRangeParts[1].trim()
      ? dateRangeParts[0].trim()
      : value;

  return (
    <button type="button" className="DatePicker_button" onClick={onClick}>
      <span className="DatePicker_label">{labelText}</span>
      <span className="DatePicker_value">{dateValue}</span>
    </button>
  );
}
/* eslint-enable react/prop-types */

const propTypes = exact({
  blockName: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  labelText: PropTypes.string.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
});

const defaultProps = {
  blockName: null,
};

function DateRangePicker(props) {
  const containerClasses = classNames(props.blockName, 'DateRangePicker');

  return (
    <div className={containerClasses}>
      <ReactDatePicker
        customInput={<DatePickerInput labelText={props.labelText} />}
        dateFormat="dd/MM/yyyy"
        minDate={moment().toDate()}
        onChange={props.handleChange}
        openToDate={props.selectedValues[0]}
        placeholderText="Click to select a date"
        selected={props.selectedValues[0]}
        startDate={props.selectedValues[0]}
        endDate={props.selectedValues[1]}
        selectsRange
        onCalendarClose={() => {
          if (!props.selectedValues[1]) {
            props.handleChange([props.selectedValues[0], props.selectedValues[0]]);
          }
        }}
      />
    </div>
  );
}

DateRangePicker.propTypes = propTypes;
DateRangePicker.defaultProps = defaultProps;

export default DateRangePicker;
